import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';
import { GalleryImage } from '../location-data.model';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { ReturnsUkService } from '../returns-uk.service';
import { ReturnstremserviceService } from '../../spartacus/services/returnstremservice.service';
import { shareReplay, Subscription, take } from 'rxjs';
import { CmsService } from '@spartacus/core';
@Component({
    selector: 'app-file-upload-modal',
    templateUrl: './file-upload-modal.component.html',
    styleUrls: ['./file-upload-modal.component.scss'],
    standalone: false
})
export class FileUploadModalComponent {
  @Output() imagesUploaded = new EventEmitter<{ locationID: string, images: GalleryImage[], files: File[] }>();
  @Output() imageCountUpdated = new EventEmitter<{ locationID: string, count: number }>();
locationID: string;
selectedImage: GalleryImage | null = null;
selectedIndex: number = -1;
slideLeft: boolean = false;
slideRight: boolean = false;
checkboxStates: { [key: string]: boolean } = {};
checkboxErrorMessages: { [key: string]: string } = {};
imgUploadarea: boolean = true;
imgGalleryarea:boolean = false;
thumbImgarea:boolean = false;
shwDonebtn:boolean = false;
qrcode:string='';
season:string=''
qrurl:string='';
location:string=''
private sub = new Subscription();
qrcodetoken:string='';
stream:boolean=false;
uploadjobbagcode: any="";
constructor(
  private dialogRef: MatDialogRef<FileUploadModalComponent>,
  private returnsUkService: ReturnsUkService,
  @Inject(MAT_DIALOG_DATA) public data: any,
  private cdr: ChangeDetectorRef,
 private component: CmsService
) {
  this.locationID = data.locationID;
  this.qrcode=data.url;
  this.season=data.season;
  this.qrcodetoken=data.qrtoken;
  this.stream=data.stream;
  this.location=data.locname
  this.returnsUkService.getnewqr().subscribe(res=>{
    if(res && res.location== this.locationID){
    this.locationID = res.location;
    this.qrcode=res.url;
    this.qrcodetoken=res.qrtoken;
    this.stream=res.stream;
    this.location=res.locationname;
    this.qrurl=encodeURI(window.location.href.split('/returns')[0] +  this.qrcode +'/' + this.season +'/' + this.locationID + '/'+ this.location);
console.log(this.qrurl)

    }
  })

   this.returnsUkService.getmodalimage().subscribe(value=>{
    if(value && value== this.locationID){
 const images = this.returnsUkService.getImages(this.locationID);
  if (images.length > 0) {
    this.selectedIndex = 0;
    this.selectedImage = images[0];
    this.imgGalleryarea = true;
    this.imgUploadarea = false;
    this.thumbImgarea = true;
    this.shwDonebtn = true;
  } 
} 
}); 
}

get locationImages(): GalleryImage[] {
  return this.returnsUkService.getImages(this.locationID);
}

get locationImageFiles(): File[] {
  return this.returnsUkService.getImageFiles(this.locationID);
}

// onFileDrop(files: NgxFileDropEntry[]): void {
//   for (const droppedFile of files) {
//     if (droppedFile.fileEntry.isFile) {
//       const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
//       fileEntry.file((file: File) => {
//         const validImageTypes = ['image/jpeg', 'image/png'];
//         const maxSizeInMB = 5;
//         const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

//         if (!validImageTypes.includes(file.type)) {
//           alert('Only image files are allowed!');
//         } else if (file.size > maxSizeInBytes) {
//           alert(`File size must be lesser than ${maxSizeInMB}MB.`);
//         } else {
          
//           const reader = new FileReader();
//           reader.onload = (e: any) => {
//             const image: GalleryImage = { src: e.target.result, thumb: e.target.result, name: file.name };
//             // Store the image in the service for display purposes
//             this.returnsUkService.addImage(this.locationID, image);
//             this.imgGalleryarea = true;
//           this.imgUploadarea = false;
//           this.thumbImgarea = true;
//           this.shwDonebtn = true;
//             this.cdr.detectChanges(); // Detect changes
//             if (this.locationImages.length === 1) {
//               this.selectedImage = image;
//               this.selectedIndex = 0;
//             }
//              // Emit the updated image count
//              this.imageCountUpdated.emit({ locationID: this.locationID, count: this.locationImages.length });
//           };
//           reader.readAsDataURL(file);
//           // Store the original file in the service for payload
//           this.returnsUkService.addImageFile(this.locationID, file);
//           // Update checkbox state
          
//           this.checkboxStates[this.locationID] = false;
//           this.cdr.detectChanges(); 
          
//         }
//       });
//     } else {
//       const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
//     }
//   }
// }

onFileDrop(files: NgxFileDropEntry[]): void {
  const validMimeTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const validExtensions = ['jpg', 'jpeg', 'png'];
  const maxSizeInMB = 5;
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

  for (const droppedFile of files) {
    // Reject non-file entries (folders)
    if (!droppedFile.fileEntry.isFile) {
      alert('Only JPEG or PNG image files are allowed!');
      return; 
    }

    // when i was uploading folder containing images it was accepting to prevent that 
    if (
      droppedFile.relativePath &&
      (droppedFile.relativePath.includes('/') || droppedFile.relativePath.includes('\\'))
    ) {
      alert('Only JPEG or PNG image files are allowed!');
      return; 
    }

    const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

    // Important: wrap each callback to avoid multiple alerts
    fileEntry.file((file: File) => {
      const fileName = file.name || '';
      const extension = (fileName.split('.').pop() || '').toLowerCase();

      const hasValidMime = file.type && validMimeTypes.includes(file.type);
      const hasValidExt = validExtensions.includes(extension);

      // Tolerant version: require at least one to be valid
      if (!hasValidMime || !hasValidExt) {
        alert('Only JPEG or PNG image files are allowed!');
        return; // do not continue processing this file
      }

      if (file.size > maxSizeInBytes) {
        alert(`File size must be less than or equal to ${maxSizeInMB} MB.`);
        return; // do not continue processing this file
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image: GalleryImage = { src: e.target.result, thumb: e.target.result, name: file.name,mobileupload:false };

        this.returnsUkService.addImage(this.locationID, image);
        this.imgGalleryarea = true;
        this.imgUploadarea = false;
        this.thumbImgarea = true;
        this.shwDonebtn = true;
        this.cdr.detectChanges();

        if (this.locationImages.length === 1) {
          this.selectedImage = image;
          this.selectedIndex = 0;
        }

        this.imageCountUpdated.emit({
          locationID: this.locationID,
          count: this.locationImages.length
        });
      };
      reader.readAsDataURL(file);

      this.returnsUkService.addImageFile(this.locationID, file);
      this.checkboxStates[this.locationID] = false;
      this.cdr.detectChanges();
    });
  }
}

uploadMore(){
  this.imgGalleryarea = false;
  this.imgUploadarea = true;
  this.thumbImgarea = true;
  this.shwDonebtn = true;
  
    this.returnsUkService.setuploadmore(this.locationID)

}
selectImage(index: number): void {
  this.selectedIndex = index;
  this.selectedImage = this.locationImages[index];
  this.imgGalleryarea = true;
  this.imgUploadarea = false;
  this.thumbImgarea = true;
  this.shwDonebtn = true;
  this.cdr.detectChanges(); 
}

previousImage(): void {
  if (this.locationImages.length > 0) {
    this.slideLeft = true;
    setTimeout(() => {
      this.selectedIndex = (this.selectedIndex - 1 + this.locationImages.length) % this.locationImages.length;
      this.selectedImage = this.locationImages[this.selectedIndex];
      this.slideLeft = false;
    }, 100); // Duration of the slide animation
  }
}

nextImage(): void {
  if (this.locationImages.length > 0) {
    this.slideRight = true;
    setTimeout(() => {
      this.selectedIndex = (this.selectedIndex + 1) % this.locationImages.length;
      this.selectedImage = this.locationImages[this.selectedIndex];
      this.slideRight = false;
    }, 100); // Duration of the slide animation
  }
}

removeSelectedImage(index:number): void {

    this.returnsUkService.removeImage(this.locationID, index);
    this.returnsUkService.removeImageFile(this.locationID, index);
    this.cdr.detectChanges();
    if (this.locationImages.length > 0) {
      this.selectedIndex = this.selectedIndex % this.locationImages.length;
      this.selectedImage = this.locationImages[this.selectedIndex];
    } else {
      this.selectedIndex = -1;
      this.selectedImage = null;
      this.imgGalleryarea = false;
      this.imgUploadarea = true;
      this.thumbImgarea = false;
      this.cdr.detectChanges(); 
    }
    // Emit the updated image count
    this.imageCountUpdated.emit({ locationID: this.locationID, count: this.locationImages.length });
  
}

onClose(): void {
  this.imagesUploaded.emit({ locationID: this.locationID, images: this.locationImages, files: this.locationImageFiles });
  this.dialogRef.close();
}

uploadImages(): void {
  this.imagesUploaded.emit({ locationID: this.locationID, images: this.locationImages, files: this.locationImageFiles });
  this.dialogRef.close();
}
   
ngOnInit(): void {
  
  this.qrurl=encodeURI(window.location.href.split('/returns')[0] +  this.qrcode +'/' + this.season +'/' + this.locationID + '/' + this.location);
  console.log(this.qrurl)
  const images = this.returnsUkService.getImages(this.locationID);
  if (images.length > 0) {
    this.selectedIndex = 0;
    this.selectedImage = images[0];
    this.imgGalleryarea = true;
    this.imgUploadarea = false;
    this.thumbImgarea = true;
    this.shwDonebtn = true;
      this.cdr.detectChanges();
  }
   this.component.getComponentData('uploadimagepopupJobBagCode').subscribe((data)=>{
      this.uploadjobbagcode = data;
      this.cdr.detectChanges();
  });
}
}
